var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "22.357%",
    cy: "8.811%",
    r: "113.202%",
    fx: "22.357%",
    fy: "8.811%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800",
    offset: "9.157%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "17.39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB00",
    offset: "25.28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "32.95%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7000",
    offset: "40.46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4700",
    offset: "47.86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1800",
    offset: "55.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    offset: "58.22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: "2.552%",
    cy: "14.432%",
    r: "139.457%",
    fx: "2.552%",
    fy: "14.432%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0E3",
    offset: "20.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A5DB",
    offset: "38.98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0292CD",
    offset: "57.37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0377BA",
    offset: "75.46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0455A1",
    offset: "93.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#054696",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    fill: "#000000",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(11 24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.48,23.9907975 C28.48,24.4159509 28.18,24.9423313 27.82,25.1447853 L14.96,32.6558282 C14.6,32.8785276 14,32.8785276 13.64,32.6558282 L0.78,25.1447853 C0.42,24.9220859 0.12,24.4159509 0.12,23.9907975 L0.12,8.94846626 C0.12,8.52331288 0.42,7.99693252 0.78,7.79447853 L13.64,0.283435583 C14,0.0607361963 14.6,0.0607361963 14.96,0.283435583 L27.82,7.79447853 C28.18,8.01717791 28.48,8.52331288 28.48,8.94846626 L28.48,23.9907975 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "99.88 10.042 88.36 10.042 88.36 12.815 92.48 12.815 92.48 24.72 95.74 24.72 95.74 12.815 99.88 12.815"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "47.56 10.042 36.04 10.042 36.04 12.815 40.18 12.815 40.18 24.72 43.44 24.72 43.44 12.815 47.56 12.815"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M80.9,9.57607362 C77.28,9.57607362 75.26,11.9245399 75.26,15.3055215 L75.26,24.7196319 L78.48,24.7196319 L78.48,15.2245399 C78.48,13.7466258 79.34,12.6128834 80.94,12.6128834 C82.52,12.6128834 83.38,13.9490798 83.38,15.2245399 L83.38,24.7196319 L86.6,24.7196319 L86.6,15.3055215 C86.6,11.9245399 84.52,9.57607362 80.9,9.57607362 L80.9,9.57607362 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "68.72 10.042 68.72 24.72 71.96 24.72 71.96 10.042"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "57.8 15.872 57.92 16.52 60.94 24.72 62.26 24.72 66.38 10.042 63.2 10.042 61.22 17.755 61.12 18.585 60.96 17.755 58.32 10.042 57.28 10.042 54.66 17.755 54.5 18.585 54.38 17.755 52.42 10.042 49.24 10.042 53.36 24.72 54.68 24.72 57.7 16.52 57.8 15.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M20.98,16.5202454 L17.64,21.5006135 L15.92,18.8282209 L17.9,15.8319018 C18.26,15.3055215 19.06,13.8276074 18.14,11.8233129 C17.4,10.203681 15.8,9.41411043 14.4,9.41411043 C13,9.41411043 11.46,10.1429448 10.66,11.8233129 C9.74,13.7466258 10.54,15.2650307 10.88,15.7711656 C10.88,15.7711656 11.98,17.4110429 12.9,18.7877301 L14.4,20.9742331 L16.64,24.4361963 C16.66,24.4564417 17.02,25.0030675 17.64,25.0030675 C18.24,25.0030675 18.6,24.4564417 18.66,24.3957055 L23.92,16.5202454 L20.98,16.5202454 L20.98,16.5202454 Z M14.4,16.6417178 C14.4,16.6417178 13.52,15.2852761 12.96,14.3539877 C12.34,13.3417178 13.04,11.8435583 14.4,11.8435583 C15.78,11.8435583 16.46,13.3417178 15.84,14.3539877 C15.28,15.3055215 14.4,16.6417178 14.4,16.6417178 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M11.16,21.3386503 L7.86,16.6619632 C7.86,16.6619632 6.98,15.3055215 6.42,14.3742331 C5.8,13.3619632 6.5,11.8638037 7.86,11.8638037 C8.04,11.8638037 8.2,11.8840491 8.34,11.9245399 L9.5,9.77852761 C8.96,9.55582822 8.4,9.43435583 7.86,9.43435583 C6.46,9.43435583 4.92,10.1631902 4.12,11.8435583 C3.2,13.7668712 4,15.2852761 4.34,15.791411 L10.1,24.4361963 C10.14,24.5171779 10.52,25.0638037 11.12,25.0638037 C11.74,25.0638037 12.08,24.5374233 12.14,24.4564417 L13.88,21.7840491 L12.38,19.5570552 L11.16,21.3386503 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwint);
export default __webpack_public_path__ + "static/media/twint.072a88163cc7e0688f3351092f054767.svg";
export { ForwardRef as ReactComponent };